
import api from '../api';

const addStore = async (code, name, city, district, address, phone, tableCount, description,status,intervalMinutes,tags,promotions) => {

  const requestData = {
    "code": code,
    "name": name,
    "city": city,
    "district": district,
    "address": address,
    "phone": phone,
    "table_count": Number(tableCount),
    "description": description,
    "status":status,
    "tags":tags,
    "interval_minutes":intervalMinutes,
    "promotions":promotions
  }

  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/store/add", requestData);
    return response.data;
  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }
}

export default addStore;
